import { init as initApm } from '@elastic/apm-rum';

initApm({
  serviceName: 'mvr-frontend',
  serverUrl: process.env.ELK_SERVER_URL,
  serviceVersion: '1.0.0',
  environment: process.env.ELK_ENV,
});
